import api from './../services/api'
import axios from 'axios'
import { addProperyIfNotExists, formatYYYYMMDD } from './../services/utils'
// import { saveAs } from 'file-saver'
import { newGroup } from './groups'

const state = {
  editionMode: false,
  patients: [],
  patient: {},
  newPatient: {
    accountDescription: '',
    accountId: '',
    active: true,
    actualWeight: 0,
    address: '',
    createdBy: 0,
    createdAt: '',
    createEvents: true,
    cuit: '',
    dateOfBirth: '',
    dailyVariation: 0,
    debtor: false,
    desiredWeight: 0,
    discountRate: 0,
    diseases: [],
    dni: '',
    email: '',
    eventuals: [],
    generalInformation: [],
    group: { ...newGroup },
    groupDescription: '',
    groupId: 0,
    height: 0,
    lastMonth: false,
    lastWeights: {},
    locationDescription: '',
    medications: [],
    name: '',
    nickname: '',
    occupation: '',
    osId: 0,
    pathImagePatient: '',
    patientId: 0,
    patientStatus: [],
    paymentsHistory: [],
    phone: '',
    postalCode: '',
    questionnaire: 'NO',
    rateDescription: '',
    rateId: 0,
    rateValue: 0,
    startDate: '',
    startFile: '',
    startSubscription: new Date(),
    startWeightTable: 0,
    startWeight: 0,
    subscriptionsHistory: [],
    surname: '',
    tableInformation: '',
    takesInvoice: false,
    targetWeight: '0',
    total: 0,
    updatedAt: '',
    updatedBy: 0,
    usualWeight: 0,
    wayToPayDescription: '',
    wayToPayId: 0,
    weeklyVariation: 0,
    weeklyWeight: [],
    weekends: []
  },
  filter: '',
  errors: [],
  dialogDiseases: false,
  loading: false,
  diseasesListSelected: [],
  dialogEventuals: false,
  itemEventual: {},
  newItemEventual: {
    id: 0,
    eventualSelected: '',
    detail: '',
    eventDate: ''
  },
  dialogMedication: false,
  itemMedication: {},
  newItemMedication: {
    id: 0,
    description: ''
  },
  dialogSubscription: false,
  subscription: {},
  newSubscription: {
    discountRate: 0,
    discountAmount: 0,
    id: 0,
    month: 0,
    patientId: 0,
    rateId: 0,
    rateValue: 0,
    statusPaidOut: 1,
    surcharge: 0,
    surchargeAmount: 0,
    total: 0,
    year: 0,
    assignment: 0,
    observations: ''
  },
  dialogPayment: false,
  dialogRefund: false,
  payment: {},
  newPayment: {
    patientId: 0,
    paymentId: 0,
    paymentDate: new Date(),
    paymentAmount: 0,
    wayToPayId: 0,
    wayToPayDescription: '',
    accountId: 0,
    accountDescription: ''
  },
  paymentsAssigned: [],
  dialogGeneralInformation: false,
  itemGeneralInformation: {},
  newItemGeneralInformation: {
    id: 0,
    description: ''
  },
  dialogPhysicalActivity: false,
  itemPhysicalActivity: {},
  newItemPhysicalActivity: {
    id: 0,
    description: ''
  },
  dialogWeekend: false,
  itemWeekend: {},
  newItemWeekend: {
    id: 0,
    description: ''
  },
  drawerAllWeights: false,
  allWeights: [],
  weeklyTrackingCells: [],
  dialogWeeklyTrackingCell: false,
  weeklyTrackingCell: {},
  newWeeklyTrackingCell: {
    id: 0,
    patientId: 0,
    weekLabel: '',
    weeklyTrackingId: 0,
    text: '',
    color: ''
  },
  dialogPatientStatus: false,
  patientStatus: {},
  newPatientStatus: {
    id: 0,
    patientId: 0,
    date: '',
    status: '',
    weight: 0,
    notes: '',
    groupId: 0,
    phaseId: 0
  }
}

const mutations = {
  PATIENTS_EDITION_MODE(state, editionMode) { state.editionMode = editionMode },
  PATIENTS_PATIENTS(state, patients) { state.patients.push(...patients) },
  PATIENTS_FILTER(state, filter) { state.filter = filter },
  PATIENTS_EMPTY_PATIENTS(state) { state.patients = [] },
  PATIENTS_PATIENT(state, patient) { state.patient = addProperyIfNotExists(patient, state.newPatient) },
  PATIENTS_PATIENT_PROP(state, payload) { state.patient[payload.property] = payload.value },
  PATIENTS_EMPTY_ERRORS(state) { state.errors = [] },
  PATIENTS_ADD_ERROR(state, error) { state.errors.push(error) },
  PATIENTS_DIALOG_DISEASES(state, dialogoDiseases) { state.dialogDiseases = dialogoDiseases },
  PATIENTS_LOADING(state, loading) { state.loading = loading },
  PATIENTS_DISEASES_LIST_SELECTED(state, diseasesListSelected) { state.diseasesListSelected = diseasesListSelected },
  PATIENTS_DIALOG_EVENTUALS(state, dialogEventuals) { state.dialogEventuals = dialogEventuals },
  PATIENTS_ITEM_EVENTUAL(state, itemEventual) { state.itemEventual = addProperyIfNotExists(itemEventual, JSON.parse(JSON.stringify(state.newItemEventual))) },
  PATIENTS_ITEM_EVENTUAL_PROP(state, payload) { state.itemEventual[payload.property] = payload.value },
  PATIENTS_DIALOG_MEDICATION(state, dialogMedication) { state.dialogMedication = dialogMedication },
  PATIENTS_ITEM_MEDICATION(state, itemMedication) { state.itemMedication = addProperyIfNotExists(itemMedication, JSON.parse(JSON.stringify(state.newItemMedication))) },
  PATIENTS_ITEM_MEDICATION_PROP(state, payload) { state.itemMedication[payload.property] = payload.value },
  PATIENTS_DIALOG_SUBSCRIPTION(state, dialogSubscription) { state.dialogSubscription = dialogSubscription },
  PATIENTS_SUBSCRIPTION(state, subscription) { state.subscription = addProperyIfNotExists(subscription, JSON.parse(JSON.stringify(state.newSubscription))) },
  PATIENTS_SUBSCRIPTION_PROP(state, payload) { state.subscription[payload.property] = payload.value },
  PATIENTS_DIALOG_PAYMENT(state, dialogPayment) { state.dialogPayment = dialogPayment },
  PATIENTS_PAYMENT(state, payment) { state.payment = addProperyIfNotExists(payment, JSON.parse(JSON.stringify(state.newPayment))) },
  PATIENTS_PAYMENT_PROP(state, payload) { state.payment[payload.property] = payload.value },
  PATIENTS_PAYMENTS_ASSIGNED(state, paymentsAssigned) { state.paymentsAssigned = paymentsAssigned },
  PATIENTS_DIALOG_GENERAL_INFORMATION(state, dialogGeneralInformation) { state.dialogGeneralInformation = dialogGeneralInformation },
  PATIENTS_ITEM_GENERAL_INFORMATION(state, itemGeneralInformation) { state.itemGeneralInformation = addProperyIfNotExists(itemGeneralInformation, JSON.parse(JSON.stringify(state.newItemGeneralInformation))) },
  PATIENTS_ITEM_GENERAL_INFORMATION_PROP(state, payload) { state.itemGeneralInformation[payload.property] = payload.value },
  PATIENTS_DRAWER_ALL_WEIGHTS(state, value) { state.drawerAllWeights = value},
  PATIENTS_ALL_WEIGHTS(state, weights) { state.allWeights = weights },
  PATIENTS_DIALOG_REFUND(state, dialogRefund) { state.dialogRefund = dialogRefund },
  PATIENTS_DIALOG_PHYSICAL_ACTIVITY(state, dialogPhysicalActivity) { state.dialogPhysicalActivity = dialogPhysicalActivity },
  PATIENTS_ITEM_PHYSICAL_ACTIVITY(state, itemPhysicalActivity) { state.itemPhysicalActivity = addProperyIfNotExists(itemPhysicalActivity, JSON.parse(JSON.stringify(state.newItemPhysicalActivity))) },
  PATIENTS_ITEM_PHYSICAL_ACTIVITY_PROP(state, payload) { state.itemPhysicalActivity[payload.property] = payload.value },
  PATIENTS_DIALOG_WEEKEND(state, dialogWeekend) { state.dialogWeekend = dialogWeekend },
  PATIENTS_ITEM_WEEKEND(state, itemWeekend) { state.itemWeekend = addProperyIfNotExists(itemWeekend, JSON.parse(JSON.stringify(state.newItemWeekend))) },
  PATIENTS_ITEM_WEEKEND_PROP(state, payload) { state.itemWeekend[payload.property] = payload.value },
  PATIENTS_WEEKLY_TRACKING_CELLS(state, cells) { state.weeklyTrackingCells = cells },
  PATIENTS_DIALOG_WEEKLY_TRACKING_CELL(state, dialogWeeklyTrackingCell) { state.dialogWeeklyTrackingCell = dialogWeeklyTrackingCell },
  PATIENTS_WEEKLY_TRACKING_CELL(state, cell) { state.weeklyTrackingCell = addProperyIfNotExists(cell, JSON.parse(JSON.stringify(state.newWeeklyTrackingCell))) },
  PATIENTS_WEEKLY_TRACKING_CELL_PROP(state, payload) { state.weeklyTrackingCell[payload.property] = payload.value },
  PATIENTS_DIALOG_PATIENT_STATUS(state, dialogPatientStatus) { state.dialogPatientStatus = dialogPatientStatus },
  PATIENTS_PATIENT_STATUS(state, patientStatus) { state.patientStatus = addProperyIfNotExists(patientStatus, { ...state.newPatientStatus, date: formatYYYYMMDD(new Date()), weight: Number(state.patient.actualWeight) || 0 }) },
  PATIENTS_PATIENT_STATUS_PROP(state, payload) { state.patientStatus[payload.property] = payload.value },
}

const actions = {
  async getPatientsHTTP({ state, commit }, payload) {
    let url = `/patients/${payload.page}`

    if (state.filter && state.filter != '') {
      url = `${url}/${state.filter}`
    }

    let result = await api.get(url)
    commit('PATIENTS_PATIENTS', result.data.data)
    if (result.data.data.length == 0) {
      return true
    } else {
      return false
    }
  },
  async getPatientHTTP({ commit }, patientId) {
    let result = await api.get(`/patients/one/${patientId}`)
    let patient = result.data.data

    commit('PATIENTS_PATIENT', patient)
  },
  async savePatient({ state, commit, dispatch }) {
    const patient = Object.assign({}, state.patient)
    commit('PATIENTS_EMPTY_ERRORS')

    if (!patient.name || patient.name == '') commit('PATIENTS_ADD_ERROR', 'Debe ingresar el nombre del paciente')
    if (!patient.surname || patient.surname == '') commit('PATIENTS_ADD_ERROR', 'Debe ingresar el apellido del paciente')
    if (!patient.rateId || patient.rateId == 0) commit('PATIENTS_ADD_ERROR', 'Debe seleccionar una tarifa')
    if (patient.dateOfBirth && patient.dateOfBirth != '' && patient.dateOfBirth != '00-00-0000') {
      const [day, month, year] = patient.dateOfBirth.split('/');

      if (!day || day < 1 || day > 31 || !month || month < 1 || month > 12 || !year || year < 1930 || new Date(year, month - 1, day).getTime() > new Date(
        new Date().getFullYear() - 16,
        new Date().getMonth(),
        new Date().getDate()
      ).getTime()) {
        commit('PATIENTS_ADD_ERROR', 'La fecha de nacimiento no es válida')
      }
    }

    if (patient.startDate && patient.startDate != '' && patient.startDate != '00-00-0000') {
      const [day, month, year] = patient.startDate.split('/');

      if (!day || day < 1 || day > 31 || !month || month < 1 || month > 12 || !year || year < 1930) {
        commit('PATIENTS_ADD_ERROR', 'La fecha de inicio no es válida')
      }
    }

    if (state.errors.length == 0) {
      if (state.patient.patientId == 0) {
        return await dispatch('createPatientHTTP')
      } else {
        return await dispatch('updatePatientHTTP')
      }
    }

  },
  async savePatientStartWeightHTTP({ state, rootState }) {
    
    const patient = Object.assign({}, state.patient);
    await api.patch('/patients', { patientId: patient.patientId, startWeightTable: patient.startWeightTable, updateBy: rootState.user.userId })
    return 'Peso inicial actualizado!'
  },
  async createPatientHTTP({ state, rootState }) {
    const patient = Object.assign({}, state.patient)
    patient.createdBy = rootState.user.userId
    patient.updatedBy = rootState.user.userId

    await api.post('/patients', patient)
    return 'Paciente creado!'
  },
  async updatePatientHTTP({ state, rootState }) {
    const patient = Object.assign({}, state.patient)
    patient.updatedBy = rootState.user.userId
    await api.put('/patients', patient)
    return 'Paciente actalizado!'
  },
  //eslint-disable-next-line
  async avatarUploadHTTP({ commit }, file) {
    var formData = new FormData()
    formData.append('file', file.file)
    formData.append('upload_preset', 'vkvg1rjl')
    axios({
      method: 'POST',
      url: `https://api.cloudinary.com/v1_1/planadev/upload`,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: formData
    })
      .then(data => {

        commit('PATIENTS_PATIENT_PROP', { property: 'pathImagePatient', value: data.data.secure_url })
      })
      .catch(err => err)
  },
  //eslint-disable-next-line
  async initialFileUploadHTTP({ state, commit }, file) {
    var formData = new FormData()
    formData.append('file', file.file)
    let result = await api.put(`/uploads/startFile/${state.patient.patientId}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    commit('PATIENTS_PATIENT_PROP', { property: 'startFile', value: `${file.file.name}` })
    return result.data.data
  },
  async saveDiseasesPatient({ state, rootState }) {
    let diseases = rootState.diseases.diseases.filter(item => state.diseasesListSelected.indexOf(item.diseaseDescription) >= 0)
    let data = {
      diseases: diseases,
      patientId: state.patient.patientId,
      createdBy: rootState.user.userId,
      updatedBy: rootState.user.userId
    }
    await api.post('/patients/diseases', data)
    return 'Enfermedades de base guardadas'
  },
  async saveEventualsPatient({ state, dispatch, rootState }) {
    let eventual
    if(state.itemEventual.eventualSelected) {
      eventual = rootState.eventuals.eventuals.filter(item => state.itemEventual.eventualSelected.indexOf(item.eventualDescription) >= 0)[0]
    }

    if (state.itemEventual.id == 0) {
      return await dispatch('createEventualsPatientHTTP', eventual)
    } else {
      return await dispatch('updateEventualsPatientHTTP', eventual)
    }
  },
  async createEventualsPatientHTTP({ state, rootState }, eventual) {
    let data = {
      detail: state.itemEventual.detail,
      eventDate: state.itemEventual.eventDate,
      eventual: eventual ? eventual : {},
      patientId: state.patient.patientId,
      createdBy: rootState.user.userId,
      updatedBy: rootState.user.userId,
    }
    await api.post('/patients/eventuals', data)
    return 'Información eventual creada'
  },
  async updateEventualsPatientHTTP({ state, rootState }, eventual) {

    let data = {
      id: state.itemEventual.id,
      detail: state.itemEventual.detail,  
      eventDate: state.itemEventual.eventDate,
      eventual: eventual ? eventual : {},
      patientId: state.patient.patientId,
      updatedBy: rootState.user.userId
    }
    await api.put('/patients/eventuals', data)
    return 'Información eventual actualizada'
  },
  async saveMedicationPatient({ state, rootState, dispatch }) {
    let data = Object.assign({}, state.itemMedication)
    data.patientId = state.patient.patientId
    data.createdBy = rootState.user.userId
    data.updatedBy = rootState.user.userId
    if (state.itemMedication.id == 0) {
      return await dispatch('createMedicationsPatientHTTP', data)
    } else {
      return await dispatch('updateMedicationsPatientHTTP', data)
    }
  },
  //eslint-disable-next-line
  async createMedicationsPatientHTTP({ }, data) {
    await api.post('/patients/medications', data)
    return 'Item creado'
  },
  //eslint-disable-next-line
  async updateMedicationsPatientHTTP({ }, data) {
    await api.put('/patients/medications', data)
    return 'Item actualizado'
  },
  async deleteMedicationPatientHTTP({ state }) {
    await api.delete(`/patients/medications/${state.itemMedication.id}`)
    return 'Item eliminado'
  },
  async getPaymentHistoryHTTP({ commit }, patientId) {
    let result = await api.get(`/patients/one/${patientId}`)
    commit('PATIENTS_PATIENT', result.data.data)
  },
  async saveSubscription({ state, dispatch, rootState }) {
    let userId = rootState.user.userId
    let subscription = { ...state.subscription }
    subscription.userId = userId

    if (state.subscription.id == 0) {
      return await dispatch('createPatientSubscriptionHTTP', subscription)
    } else {
      return await dispatch('updatePatientSubscriptionHTTP', subscription)
    }
  },
  //eslint-disable-next-line
  async createPatientSubscriptionHTTP({ }, subscription) {
    await api.post('/patients/subscription', subscription)
    return
  },
  //eslint-disable-next-line
  async updatePatientSubscriptionHTTP({ }, subscription) {
    await api.put('/patients/subscription', subscription)
    return
  },
  async savePayment({ state, dispatch, rootState }) {
    let userId = rootState.user.userId
    console.log(state.payment)
    let payment = { ...state.payment }
    console.log(payment)
    payment.userId = userId
    payment.patientId = state.patient.patientId

    if (state.payment.paymentId == 0) {
      return await dispatch('createPaymentPatientHTTP', payment)
    } else {
      return await dispatch('updatePaymentPatientHTTP', payment)
    }
  },
  //eslint-disable-next-line
  async createPaymentPatientHTTP({ }, payment) {
    await api.post('/patients/payment', payment)

  },
  //eslint-disable-next-line
  async updatePaymentPatientHTTP({ }, payment) {
    await api.put('/patients/payment', payment)
  },
  async getPaymentsAssignedHTTP({ commit }, subscriptionId) {
    const result = await api.get(`/patients/paymentsAssigned/${subscriptionId}`)
    commit('PATIENTS_PAYMENTS_ASSIGNED', [])
    commit('PATIENTS_PAYMENTS_ASSIGNED', result.data.data)
  },
  async getChartWeightsHTTP({ state }) {

    let result = await api.post(`/patients/chartWeights/${state.patient.patientId}`)
    if (result) {
      window.open(`${process.env.VUE_APP_URLAPI}/pdfs/chartWeights/${state.patient.patientId}.pdf`, '_blank')
    }
  },
  async saveGeneralInformationPatient({ state, rootState, dispatch }) {
    let data = Object.assign({}, state.itemGeneralInformation)
    data.patientId = state.patient.patientId
    data.createdBy = rootState.user.userId
    data.updatedBy = rootState.user.userId
    if (state.itemGeneralInformation.id == 0) {
      return await dispatch('createGeneralInformationPatientHTTP', data)
    } else {
      return await dispatch('updateGeneralInformationPatientHTTP', data)
    }
  },
  //eslint-disable-next-line
  async createGeneralInformationPatientHTTP({ }, data) {
    await api.post('/patients/generalInformation', data)
    return 'Información general creada'
  },
  //eslint-disable-next-line
  async updateGeneralInformationPatientHTTP({ }, data) {
    await api.put('/patients/generalInformation', data)
    return 'Información general actualizada'
  },
  async deleteGeneralInformationatientHTTP({ state }) {
    await api.delete(`/patients/generalInformation/${state.itemGeneralInformation.id}`)
    return 'Información general eliminada'
  },
  async getAllWeightsPatientHTTP({ state, commit }, payload) {
    let url = `/patients/weights/${state.patient.patientId}/${payload.page}`

    let result = await api.get(url)
    commit('PATIENTS_ALL_WEIGHTS', result.data.data)
    if (result.data.data.length == 0) {
      return true
    } else {
      return false
    }
  },
  async savePhysicalActivityPatient({ state, rootState, dispatch }) {
    let data = Object.assign({}, state.itemPhysicalActivity)
    data.patientId = state.patient.patientId
    data.createdBy = rootState.user.userId
    data.updatedBy = rootState.user.userId
    if (state.itemPhysicalActivity.id == 0) {
      return await dispatch('createPhysicalActivityPatientHTTP', data)
    } else {
      return await dispatch('updatePhysicalActivityPatientHTTP', data)
    }
  },
  //eslint-disable-next-line
  async createPhysicalActivityPatientHTTP({ }, data) {
    await api.post('/patients/physicalActivity', data)
    return 'Actividad física creada'
  },
  //eslint-disable-next-line
  async updatePhysicalActivityPatientHTTP({ }, data) {
    await api.put('/patients/physicalActivity', data)
    return 'Actividad física actualizada'
  },
  async deletePhysicalActivityPatientHTTP({ state }) {
    await api.delete(`/patients/physicalActivity/${state.itemPhysicalActivity.id}`)
    return 'Actividad física eliminada'
  },
  async saveWeekendPatient({ state, rootState, dispatch }) {
    let data = Object.assign({}, state.itemWeekend)
    data.patientId = state.patient.patientId
    data.createdBy = rootState.user.userId
    data.updatedBy = rootState.user.userId
    if (state.itemWeekend.id == 0) {
      return await dispatch('createWeekendPatientHTTP', data)
    } else {
      return await dispatch('updateWeekendPatientHTTP', data)
    }
  },
  //eslint-disable-next-line
  async createWeekendPatientHTTP({ }, data) {
    await api.post('/patients/weekend', data)
    return 'Actividad de resumen mensual creada'
  },
  //eslint-disable-next-line
  async updateWeekendPatientHTTP({ }, data) {
    await api.put('/patients/weekend', data)
    return 'Actividad de resumen mensual actualizada'
  },
  async deleteWeekendPatientHTTP({ state }) {
    await api.delete(`/patients/weekend/${state.itemWeekend.id}`)
    return 'Actividad de resumen mensual eliminada'
  },
  async getWeeklyTrackingCellsHTTP({ commit }, patientId) {
    let result = await api.get(`/patients/weeklyTracking/${patientId}`)
    commit('PATIENTS_WEEKLY_TRACKING_CELLS', result.data.data)
  },
  async saveWeeklyTrackingCell({ state, dispatch, rootState }) {
    let data = Object.assign({}, state.weeklyTrackingCell)
    data.patientId = state.patient.patientId
    data.createdBy = rootState.user.userId
    data.updatedBy = rootState.user.userId
    
    if (!data.text || data.text.trim() === '') {
      if (data.id != 0) {
        return await dispatch('deleteWeeklyTrackingCellHTTP', data)
      }
      return 'Celda vacía'
    }
    
    if (state.weeklyTrackingCell.id == 0) {
      return await dispatch('createWeeklyTrackingCellHTTP', data)
    } else {
      return await dispatch('updateWeeklyTrackingCellHTTP', data)
    }
  },
  //eslint-disable-next-line
  async createWeeklyTrackingCellHTTP({ }, data) {
    await api.post('/patients/weeklyTracking', data)
    return 'Celda creada'
  },
  //eslint-disable-next-line
  async updateWeeklyTrackingCellHTTP({ }, data) {
    await api.put('/patients/weeklyTracking', data)
    return 'Celda actualizada'
  },
  //eslint-disable-next-line
  async deleteWeeklyTrackingCellHTTP({ }, data) {
    await api.delete(`/patients/weeklyTracking/${data.id}`)
    return 'Celda eliminada'
  },
  async savePatientStatusHTTP({ state, rootState }) {
    const isActive = state.patient.active == true || state.patient.active == 1
    
    const data = {
      patientId: state.patient.patientId,
      date: state.patientStatus.date,
      status: isActive ? 'baja' : 'alta',
      weight: state.patientStatus.weight,
      notes: state.patientStatus.notes,
      createdBy: rootState.user.userId,
      group: state.patient.group.groupDescription || '',
      phase: state.patient.group && state.patient.group.phaseDescription ? state.patient.group.phaseDescription : '',
      groupId: state.patient.group && state.patient.group.groupId || null,
      phaseId: state.patient.group && state.patient.group.phaseId || null,
    }

    await api.post('/patients/status', data)
    return isActive ? 'Paciente dado de baja' : 'Paciente dado de alta'
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}